"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getLocationTo_1 = __importDefault(require("../../../../modules/getLocationTo"));
const urlHandler_1 = require("../../../../modules/urlHandler");
const searchBtnHandler = ({ inputValue, setInputValue, setFocus, setRecentSearchList, setRecentList, }) => {
    setInputValue(inputValue);
    setFocus(false);
    window.location.href = (0, urlHandler_1.setQueryParams)({ query: inputValue }, (0, getLocationTo_1.default)());
    setRecentSearchList({
        type: "query",
        content: inputValue,
        query: inputValue,
    }, setRecentList);
};
exports.default = searchBtnHandler;
